import { Box, Grid } from '@mui/material';
import { FC } from 'react';
import InputControl from '../../input-control';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import useAppData from '@/hooks/use-app-data.hook';
import { AppDataQueryKey } from '@/lib/query-client';
import { PublicServiceMeta } from '@/lib/models/public-service/public-service.model';
import { getListedNewServices } from '@/lib/models/public-service';
import Text from '@/components/text';
import GradientPanel from '@/components/gradient-panel';

interface Props {
  formHandle: FormHandle<PolicyModelV1>;
  canChangePolicy: boolean;
  policy: PolicyModelV1;
}

const NewServicesV1: FC<Props> = ({ formHandle, canChangePolicy, policy }) => {
  const { data: publicServices = [] } = useAppData<PublicServiceMeta[]>(
    AppDataQueryKey.PublicServices
  );
  const hasNewServices = !!getListedNewServices(publicServices, policy.newPublicServices).length;

  if (!hasNewServices) {
    return null;
  }

  return (
    <GradientPanel>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Box mb={2}>
            <Text bold color="white">
              Our Service Catalog is Growing!
            </Text>
          </Box>
          <Text size="small" color="white">
            Popular new services were added to our catalog in the past 30 days. New services are set
            to <b>monitor mode</b> by default, ensuring that traffic is not interrupted while you
            decide on the appropriate policy.
          </Text>
        </Grid>
        <Grid item xs={8}>
          <InputControl
            name="publicServices"
            type="new-services-list-v1"
            formHandle={formHandle}
            readonly={!canChangePolicy}
            policy={policy}
          />
        </Grid>
      </Grid>
    </GradientPanel>
  );
};

export default NewServicesV1;
